import React, { useState, useMemo, useEffect, useRef } from "react";
import DataTable from "react-data-table-component";
import { customStyles } from "../../assets/table-style";
import CustomDatePicker from "../../components/CustomDatePicker";
import { format } from "date-fns";
import BASE_URL from "../../assets/global/url";
import { PaginationControls } from "../../hooks/customHook/paginationHook/usePagination";
import { useServerPagination } from "../../hooks/customHook/paginationHook/useServerPagination";
import FilterStore from "../../hooks/customHook/FilterStore";
import ExpandedRow from "./component/expandedRow";
const tabModules = [
  {
    label: "Purchase Management",
    value: "Purchase Management",
    hint: "purchase orders",
    icon: (
      <svg
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z" />
        <path d="M3 6h18" />
        <path d="M16 10a4 4 0 0 1-8 0" />
      </svg>
    ),
  },
  {
    label: "Sales Management",
    value: "Sales Management",
    hint: "sales invoices",
    icon: (
      <svg
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M3 3v16a2 2 0 0 0 2 2h16" />
        <path d="m19 9-5 5-4-4-3 3" />
      </svg>
    ),
  },
  {
    label: "Expenses",
    value: "EXPENSE",
    hint: "expense entries",
    icon: (
      <svg
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8Z" />
        <path d="M14 2v6h6" />
        <path d="M9 13h6M9 17h6" />
      </svg>
    ),
  },
  {
    label: "Inventory Counting",
    value: "Inventory Counting",
    hint: "inventory counting records",
    icon: (
      <svg
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M9 3h6a1 1 0 0 1 1 1v1H8V4a1 1 0 0 1 1-1Z" />
        <path d="M16 5h2a2 2 0 0 1 2 2v13a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h2" />
        <path d="m9 13 2 2 4-4" />
      </svg>
    ),
  },
  {
    label: "Stock Transfer",
    value: "Stock Transfer",
    hint: "Stock Transfer records",
    icon: (
      <svg
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M9 3h6a1 1 0 0 1 1 1v1H8V4a1 1 0 0 1 1-1Z" />
        <path d="M16 5h2a2 2 0 0 1 2 2v13a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h2" />
        <path d="m9 13 2 2 4-4" />
      </svg>
    ),
  },
  {
    label: "Production",
    value: "Production",
    hint: "Production records",
    icon: (
      <svg
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M9 3h6a1 1 0 0 1 1 1v1H8V4a1 1 0 0 1 1-1Z" />
        <path d="M16 5h2a2 2 0 0 1 2 2v13a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h2" />
        <path d="m9 13 2 2 4-4" />
      </svg>
    ),
  },
  {
    label: "Other Income",
    value: "Other Income",
    hint: "Other Income records",
    icon: (
      <svg
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M9 3h6a1 1 0 0 1 1 1v1H8V4a1 1 0 0 1 1-1Z" />
        <path d="M16 5h2a2 2 0 0 1 2 2v13a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h2" />
        <path d="m9 13 2 2 4-4" />
      </svg>
    ),
  },
  {
    label: "Fixed Asset",
    value: "Fixed Asset",
    hint: "Fixed Asset records",
    icon: (
      <svg
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M9 3h6a1 1 0 0 1 1 1v1H8V4a1 1 0 0 1 1-1Z" />
        <path d="M16 5h2a2 2 0 0 1 2 2v13a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h2" />
        <path d="m9 13 2 2 4-4" />
      </svg>
    ),
  },
  {
    label: "Profit Distribution",
    value: "Profit Distribution",
    hint: "Profit Distribution records",
    icon: (
      <svg
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M21 12a9 9 0 1 1-9-9v9Z" />
        <path d="M15 3.5A9 9 0 0 1 20.5 9H15Z" />
      </svg>
    ),
  },
];

// const ExpandedRow = ({ data }) => {
//   if (!data.changes || data.changes.length === 0) {
//     return (
//       <div className="p-3 bg-light">
//         <p className="fst-italic text-muted mb-0 small">
//           No field-level changes recorded for this action.
//         </p>
//         {data.remarks && (
//           <div className="alert alert-warning py-2 px-3 mt-3 mb-0 small">
//             <strong
//               className="d-block text-uppercase"
//               style={{ fontSize: "0.7rem", letterSpacing: "0.04em" }}
//             >
//               Remarks
//             </strong>
//             {data.remarks}
//           </div>
//         )}
//       </div>
//     );
//   }

//   return (
//     <div className="p-3 bg-light">
//       <div className="table-responsive">
//         <table className="table table-sm table-bordered bg-white mb-2 align-middle">
//           <thead className="table-light">
//             <tr>
//               <th
//                 className="small text-uppercase text-muted"
//                 style={{ letterSpacing: "0.04em" }}
//               >
//                 Field
//               </th>
//               <th
//                 className="small text-uppercase text-muted"
//                 style={{ letterSpacing: "0.04em" }}
//               >
//                 Old value
//               </th>
//               <th className="text-center" style={{ width: "36px" }}></th>
//               <th
//                 className="small text-uppercase text-muted"
//                 style={{ letterSpacing: "0.04em" }}
//               >
//                 New value
//               </th>
//             </tr>
//           </thead>
//           <tbody>
//             {data.changes.map((c, idx) => (
//               <tr key={idx}>
//                 <td className="fw-semibold">{c.field}</td>
//                 <td>
//                   <span className="badge rounded-pill text-danger bg-danger bg-opacity-10 fw-normal text-decoration-line-through">
//                     {c.oldValue ?? "—"}
//                   </span>
//                 </td>
//                 <td className="text-center text-muted">→</td>
//                 <td>
//                   <span className="badge rounded-pill text-success bg-success bg-opacity-10 fw-normal">
//                     {c.newValue ?? "—"}
//                   </span>
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>
//       {data.remarks && (
//         <div className="alert alert-warning py-2 px-3 mb-0 small">
//           <strong
//             className="d-block text-uppercase"
//             style={{ fontSize: "0.7rem", letterSpacing: "0.04em" }}
//           >
//             Remarks
//           </strong>
//           {data.remarks}
//         </div>
//       )}
//     </div>
//   );
// };

const AuditLog = ({ authrztn }) => {
  // const [logs, setLogs] = useState([]); // fetched from API
  const [isLoading, setIsLoading] = useState(false);
  const [activeModule, setActiveModule] = useState(tabModules[0].value);
  const [dateTo, setDateTo] = useState("");
  const [search, setSearch] = useState("");
  const [expandedRowId, setExpandedRowId] = useState(null);
  const pagination = useServerPagination(
    `${BASE_URL}/activity_log/getAuditLogData`,
    FilterStore.AuditLOGgetPerPage(),
    {
      module_name: activeModule,
    },
  );

  // Search box only updated local state before this; it never reached the
  // API. Debounce it so we don't fire a request on every keystroke, then
  // push it into the pagination params (skip the very first mount so we
  // don't duplicate the hook's own initial fetch).
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    const timeoutId = setTimeout(() => {
      pagination.updateParams({
        module_name: activeModule,
        search: search.trim(),
        date: dateTo ? format(new Date(dateTo), "yyyy-MM-dd") : "",
      });
    }, 400);

    return () => clearTimeout(timeoutId);
  }, [search, dateTo]);

  const CustomInput = React.forwardRef(
    ({ value, onClick, generateYears }, ref) => (
      <input
        type="text"
        className="form-control"
        style={{ cursor: "pointer", caretColor: "transparent" }}
        onChange={() => {}}
        onClick={() => {
          onClick();
          const date = new Date(value).getFullYear();
          generateYears(date); // Reset/Initialize Year List based on selected date of birth
        }}
        value={value}
        ref={ref}
        placeholder="Select date"
      />
    ),
  );

  const columns = [
    {
      name: "Lastest Date / Time",
      selector: (row) => row.LatestUpdate,
      format: (row) =>
        format(new Date(row.LatestUpdate), "MMM dd, yyyy hh:mm a"),
      sortable: true,
      width: "200px",
    },
    {
      name: "Transaction Number",
      selector: (row) => row.transaction_id,
      sortable: true,
      cell: (row) => (
        <span className="fw-semibold text-dark">{row.transaction_id}</span>
      ),
    },
  ];

  const hasActiveFilters = Boolean(search || dateTo);
  const activeTab = tabModules.find((t) => t.value === activeModule);

  const clearFilters = () => {
    setSearch("");
    setDateTo("");
  };
  const handleModuleChange = (module_name) => {
    setActiveModule(module_name);
    clearFilters();
    pagination.updateParams({
      module_name: module_name,
    });
  };

  return (
    <div className="h-100 w-100 border rounded-3 bg-white custom-container overflow-hidden">
      {authrztn.includes("Currency-View") ? (
        <>
          <div className="d-flex justify-content-between align-items-start px-4 py-3 border-bottom">
            <div>
              <span className="fs-3 fw-bold">Audit Log</span>
              <p className="text-muted small mb-0 mt-1">
                Track every create, update, and delete action across your
                modules.
              </p>
            </div>
          </div>

          <div
            className="d-flex flex-column flex-md-row"
            style={{ minHeight: "500px" }}
          >
            {/* Vertical tab sidebar */}
            <div
              className="list-group list-group-flush flex-md-column bg-light border-end p-2 flex-md-nowrap overflow-auto"
              style={{ width: "100%", maxWidth: "360px", flexShrink: 0 }}
            >
              {tabModules.map((tab) => {
                const isActive = activeModule === tab.value;
                return (
                  <button
                    key={tab.value}
                    type="button"
                    onClick={() => handleModuleChange(tab.value)}
                    className={`list-group-item list-group-item-action d-flex align-items-center gap-2 border-0 rounded-2 mb-1 px-3 py-2 ${
                      isActive
                        ? "active bg-primary bg-opacity-10 text-primary fw-semibold"
                        : "text-secondary"
                    }`}
                    style={
                      isActive
                        ? { borderLeft: "3px solid var(--bs-primary)" }
                        : { borderLeft: "3px solid transparent" }
                    }
                  >
                    <span className="d-inline-flex flex-shrink-0">
                      {tab.icon}
                    </span>
                    <span className="flex-grow-1 text-start text-truncate">
                      {tab.label}
                    </span>
                    {/* <span
                      className={`badge rounded-pill ${
                        isActive
                          ? "bg-primary"
                          : "bg-secondary bg-opacity-25 text-secondary"
                      }`}
                    >
                      {moduleCounts[tab.value] ?? 0}
                    </span> */}
                  </button>
                );
              })}
            </div>

            {/* Content panel */}
            <div className="flex-grow-1 p-3">
              <div className="row g-2 align-items-center mb-3">
                <div className="col-12 col-sm-4">
                  <div className="input-group">
                    <span className="input-group-text bg-white text-muted">
                      <svg
                        width="15"
                        height="15"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <circle cx="11" cy="11" r="7" />
                        <path d="m21 21-4.35-4.35" />
                      </svg>
                    </span>
                    <input
                      type="text"
                      className="form-control border-start-0"
                      placeholder="Search reference no. / performed by"
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                    />
                  </div>
                </div>
                <div className="col-12 col-sm-4">
                  <CustomDatePicker
                    selected={dateTo ? new Date(dateTo) : ""}
                    handleDateChange={(date) => {
                      setDateTo(date);
                    }}
                    setter={setDateTo}
                    CustomInput={CustomInput}
                  />
                </div>
                {hasActiveFilters && (
                  <div className="col-auto">
                    <button
                      type="button"
                      className="btn btn-link btn-sm text-danger text-decoration-none px-1"
                      onClick={clearFilters}
                    >
                      Clear filters
                    </button>
                  </div>
                )}
                <div className="col text-sm-end text-muted small">
                  {pagination.data.length}{" "}
                  {pagination.data.length === 1 ? "entry" : "entries"}
                </div>
              </div>

              <div className="card border shadow-sm">
                <div className="card-body p-0">
                  <DataTable
                    columns={columns}
                    customStyles={customStyles}
                    className="dataTable"
                    data={pagination.data}
                    expandableRows
                    expandableRowsComponent={ExpandedRow}
                    expandableRowExpanded={(row) =>
                      row.transaction_id === expandedRowId
                    }
                    onRowExpandToggled={(bool, row) => {
                      setExpandedRowId(bool ? row.transaction_id : null);
                    }}
                    progressPending={isLoading}
                    highlightOnHover
                    pointerOnHover
                    progressComponent={
                      <div className="d-flex flex-column align-items-center py-5">
                        <div
                          className="spinner-border text-primary mb-2"
                          role="status"
                        >
                          <span className="visually-hidden">Loading…</span>
                        </div>
                        <p className="text-muted small mb-0">
                          Loading audit entries…
                        </p>
                      </div>
                    }
                    noDataComponent={
                      <div className="d-flex flex-column align-items-center text-center py-5 px-3">
                        <span className="text-secondary opacity-50 mb-2">
                          <svg
                            width="40"
                            height="40"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <rect x="3" y="4" width="18" height="16" rx="2" />
                            <path d="M8 2v4M16 2v4M3 10h18" />
                            <path
                              d="M9.5 15.5 12 13l2.5 2.5M12 13v6"
                              opacity="0.5"
                            />
                          </svg>
                        </span>
                        {hasActiveFilters ? (
                          <>
                            <p className="fw-semibold mb-1">
                              No matching entries
                            </p>
                            <p
                              className="text-muted small mb-3"
                              style={{ maxWidth: "320px" }}
                            >
                              Nothing in {activeTab?.hint} matches your current
                              filters.
                            </p>
                            <button
                              type="button"
                              className="btn btn-outline-secondary btn-sm"
                              onClick={clearFilters}
                            >
                              Clear filters
                            </button>
                          </>
                        ) : (
                          <>
                            <p className="fw-semibold mb-1">
                              {" "}
                              No Data Available
                            </p>
                            <p
                              className="text-muted small mb-0"
                              style={{ maxWidth: "320px" }}
                            >
                              There is no data to show you right now.
                            </p>
                          </>
                        )}
                      </div>
                    }
                  />

                  <PaginationControls {...pagination} />
                </div>
              </div>
            </div>
          </div>
        </>
      ) : (
        <div
          className="d-flex flex-column align-items-center justify-content-center text-center py-5"
          style={{ minHeight: "400px" }}
        >
          <span className="text-secondary opacity-50 mb-3">
            <svg
              width="36"
              height="36"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <rect x="4" y="11" width="16" height="9" rx="2" />
              <path d="M8 11V7a4 4 0 0 1 8 0v4" />
            </svg>
          </span>
          <h3 className="fs-5 fw-semibold mb-0">
            You don't have access to this function.
          </h3>
        </div>
      )}
    </div>
  );
};

export default AuditLog;
